module.exports = __webpack_public_path__ + "img/redgold.1bee54c.jpg";